import { AttachmentItem, Comment, OrderManagementRequest } from 'core/entities';
import type { Dictionary } from '@placer-ui/types';
import { RecordType } from 'features/offline-reports/order-management/components/requests-table/requests-table';

const fileTypeDictionary: Dictionary<string> = {
    pdf: 'application/x-pdf',
    xls: 'text/csv, application/vnd.ms-excel',
    xlsx: 'text/csv, application/vnd.ms-excel',
    csv: 'text/csv, application/vnd.ms-excel',
    kml: 'application/vnd.google-earth.kml+xml',
    geojson: 'application/json',
    mov: 'video/quicktime',
    mp4: 'video/mp4',
};

export const getFilesList = (comments: Comment[]) => {
    const attachmentsFileList: AttachmentItem[] = [];

    if (comments.length > 1) {
        comments.slice(1).forEach((comment) => {
            let attachments = comment.attachments;

            if (attachments.length > 0) {
                attachments.forEach((attachment) => {
                    let obj: AttachmentItem = {
                        url: '',
                        fileName: '',
                    };
                    if (attachment.content_url && attachment.file_name) {
                        obj.url = attachment.content_url;
                        obj.fileName = attachment.file_name;
                        attachmentsFileList.push(obj);
                    }
                });
            }
        });
    }
    return attachmentsFileList;
};

export const getContentTypeHeader = (attachmentsFileList: AttachmentItem[]) => {
    if (attachmentsFileList.length > 1) {
        return 'application/zip';
    }
    const fileType = attachmentsFileList[0].fileName.split('.');

    return fileTypeDictionary[fileType[fileType.length - 1]] || 'application/zip';
};

export const getReportFileName = (
    record: RecordType | OrderManagementRequest,
    contentTypeHeader: string,
    filedList: AttachmentItem[],
) => {
    let fileDate = record.reportDates;

    if (typeof fileDate !== 'string') {
        const { to, from } = fileDate || {};
        fileDate = `${from} - ${to}`;
    }

    const fileName = `${record.reportName} ${fileDate}`;

    if (contentTypeHeader === 'application/zip') {
        return fileName + '.zip';
    }
    const fileType = filedList[0].fileName.split('.');

    return `${fileName}.${fileType[fileType.length - 1]}`;
};
